"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusError = exports.RECOMMENDED_STATE_LENGTH = exports.RECOMMENDED_CODE_VERIFIER_LENGTH = exports.LOCALSTORAGE_ID = exports.UserScope = void 0;
var UserScope;
(function (UserScope) {
    UserScope["PROPERTIES"] = "props";
    UserScope["PERMISSIONS"] = "permissions";
})(UserScope = exports.UserScope || (exports.UserScope = {}));
/**
 * To store the OAuth client's data between websites due to redirection.
 */
exports.LOCALSTORAGE_ID = "@rtb/login-provider-client";
/**
 * The maximum length for a code verifier for the best security we can offer.
 * Please note the NOTE section of RFC 7636 § 4.1 - the length must be >= 43,
 * but <= 128, **after** base64 url encoding. This means 32 code verifier bytes
 * encoded will be 43 bytes, or 96 bytes encoded will be 128 bytes. So 96 bytes
 * is the highest valid value that can be used.
 */
exports.RECOMMENDED_CODE_VERIFIER_LENGTH = 96;
/**
 * A sensible length for the state's length, for anti-csrf.
 */
exports.RECOMMENDED_STATE_LENGTH = 32;
/**
 * Character set to generate code verifier defined in rfc7636.
 */
var PKCE_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
var StatusError = /** @class */ (function (_super) {
    __extends(StatusError, _super);
    function StatusError(message, status) {
        if (message === void 0) { message = ''; }
        var _this = _super.call(this, message) || this;
        _this.status = status;
        Object.setPrototypeOf(_this, StatusError.prototype);
        return _this;
    }
    return StatusError;
}(Error));
exports.StatusError = StatusError;
var sha256;
if (process.env.NODE_ENV !== 'production') {
    sha256 = require('js-sha256').sha256;
}
var hasCrypto = typeof crypto === 'object';
var isProduction = process.env.NODE_ENV === 'production';
var CryptoApi = /** @class */ (function () {
    function CryptoApi() {
    }
    CryptoApi.getRandomValues = function (array) {
        if (hasCrypto)
            return CryptoApi.cryptoGetRandomValues(array);
        if (isProduction) {
            throw Error('LoginProviderClient requires Crypto Web API');
        }
        else {
            return CryptoApi.jsGetRandomValues(array);
        }
    };
    CryptoApi.sha256 = function (data) {
        if (hasCrypto)
            return CryptoApi.cryptoSha256(data);
        if (isProduction) {
            throw Error('LoginProviderClient requires Crypto Web API');
        }
        else {
            return CryptoApi.jsSha256(data);
        }
    };
    CryptoApi.cryptoGetRandomValues = function (array) {
        return crypto.getRandomValues(array);
    };
    CryptoApi.cryptoSha256 = function (data) {
        return crypto.subtle
            .digest('SHA-256', new TextEncoder().encode(data))
            .then(CryptoApi.bufferToString);
    };
    CryptoApi.jsGetRandomValues = function (array) {
        var maxSafeInt = Math.pow(2, 32);
        var i = array.length;
        while (i--)
            array[i] = Math.floor(Math.random() * maxSafeInt);
        return array;
    };
    CryptoApi.jsSha256 = function (data) {
        return Promise.resolve(sha256.update(data).arrayBuffer()).then(CryptoApi.bufferToString);
    };
    CryptoApi.bufferToString = function (buffer) {
        var hash = new Uint8Array(buffer);
        var hashLength = hash.byteLength;
        var binary = '';
        for (var i = 0; i < hashLength; i++) {
            binary += String.fromCharCode(hash[i]);
        }
        return binary;
    };
    return CryptoApi;
}());
var LoginProvider = /** @class */ (function () {
    function LoginProvider(config) {
        var _this = this;
        var _a;
        this.state = {};
        var clientId = config.clientId, originUrl = config.originUrl;
        this.localStorageKey = "".concat(exports.LOCALSTORAGE_ID, "/").concat(clientId);
        this.refreshLockKey = "".concat(this.localStorageKey, "/refreshLock");
        var authorizationUrl = config.authorizationUrl, permissionUrl = config.permissionUrl, revokeUrl = config.revokeUrl, tokenUrl = config.tokenUrl, userUrl = config.userUrl;
        if (!authorizationUrl)
            authorizationUrl = '/oauth2/auth';
        if (!permissionUrl)
            permissionUrl = '/api/v1/user/permissions';
        if (!revokeUrl)
            revokeUrl = '/oauth2/revoke';
        if (!tokenUrl)
            tokenUrl = '/oauth2/token';
        if (!userUrl)
            userUrl = '/api/v1/user';
        this.config = __assign(__assign({}, config), { authorizationUrl: new URL(authorizationUrl, originUrl).toString(), permissionUrl: new URL(permissionUrl, originUrl).toString(), revokeUrl: new URL(revokeUrl, originUrl).toString(), tokenUrl: new URL(tokenUrl, originUrl).toString(), userUrl: new URL(userUrl, originUrl).toString(), referer: (_a = config.referer) !== null && _a !== void 0 ? _a : null });
        this.recoverState();
        var storageEventListener = function (e) {
            if (e.key === _this.localStorageKey)
                _this.recoverState();
        };
        window.addEventListener('storage', storageEventListener);
    }
    /**
     * If there is an error, it will be passed back as a rejected Promise.
     * If there is no code, the user should be redirected via
     * [fetchAuthorizationCode].
     */
    LoginProvider.prototype.isReturningFromAuthServer = function () {
        var error = LoginProvider.extractParamFromUrl(location.href, 'error');
        if (error) {
            return Promise.reject(error);
        }
        var code = LoginProvider.extractParamFromUrl(location.href, 'code');
        if (!code) {
            return Promise.resolve(false);
        }
        var stateQueryParam = LoginProvider.extractParamFromUrl(location.href, 'state');
        if (stateQueryParam !== this.state.stateQueryParam) {
            return Promise.reject(new Error('Invalid state parameter'));
        }
        this.setState(__assign(__assign({}, this.state), { authorizationCode: code, hasAuthCodeBeenExchangedForAccessToken: false }));
        var urlWithoutQueryParams = LoginProvider.removeQueryParams(location.href);
        window.history.replaceState({}, '', urlWithoutQueryParams);
        return Promise.resolve(true);
    };
    LoginProvider.prototype.fetchUser = function (fetchConfig) {
        var userUrl = this.config.userUrl;
        if (fetchConfig === null || fetchConfig === void 0 ? void 0 : fetchConfig._with)
            userUrl += "?_with=".concat(fetchConfig._with.join(','));
        return this.fetchWithToken(userUrl);
    };
    LoginProvider.prototype.fetchUserPermissions = function () {
        var permissionUrl = this.config.permissionUrl;
        return this.fetchWithToken(permissionUrl);
    };
    /**
     * Fetch an authorization grant via redirection. In a sense this function
     * doesn't return because of the redirect behavior (uses `location.replace`).
     */
    LoginProvider.prototype.fetchAuthorizationCode = function () {
        var _this = this;
        var _a = this.config, clientId = _a.clientId, redirectUrl = _a.redirectUrl, scopes = _a.scopes;
        this.generatePKCECodes().then(function (_a) {
            var codeChallenge = _a.codeChallenge, codeVerifier = _a.codeVerifier;
            var stateQueryParam = _this.generateRandomState(exports.RECOMMENDED_STATE_LENGTH);
            var referer = _this.config.referer ||
                LoginProvider.extractParamFromUrl(location.href, 'referer');
            _this.setState(__assign(__assign({}, _this.state), { referer: referer, codeChallenge: codeChallenge, codeVerifier: codeVerifier, stateQueryParam: stateQueryParam }));
            var url = _this.config.authorizationUrl +
                "?response_type=code&" +
                "client_id=".concat(encodeURIComponent(clientId), "&") +
                "redirect_uri=".concat(encodeURIComponent(redirectUrl), "&") +
                "scope=".concat(encodeURIComponent(scopes.join(' ')), "&") +
                "state=".concat(stateQueryParam, "&") +
                "code_challenge=".concat(encodeURIComponent(codeChallenge), "&") +
                "code_challenge_method=S256" +
                (referer ? "&referer=".concat(encodeURIComponent(referer)) : '');
            location.replace(url);
        });
    };
    /**
     * Tries to get the current access token. If there is none
     * it will fetch another one. If it is expired, it will fire
     * [onAccessTokenExpiry] but it's up to the user to call the refresh token
     * function. This is because sometimes not using the refresh token facilities
     * is easier.
     */
    LoginProvider.prototype.getAccessToken = function () {
        var _this = this;
        var onAccessTokenExpired = this.config.onAccessTokenExpired;
        var _a = this.state, accessToken = _a.accessToken, authorizationCode = _a.authorizationCode, hasAuthCodeBeenExchangedForAccessToken = _a.hasAuthCodeBeenExchangedForAccessToken, refreshToken = _a.refreshToken, scopes = _a.scopes;
        if (this.authCodeForAccessTokenRequest) {
            return this.authCodeForAccessTokenRequest;
        }
        if (!this.isAuthorized() || !hasAuthCodeBeenExchangedForAccessToken) {
            if (!authorizationCode)
                return Promise.reject(new Error('No authorization code'));
            this.authCodeForAccessTokenRequest =
                this.exchangeAuthCodeForAccessToken();
            return this.authCodeForAccessTokenRequest;
        }
        // Depending on the server (and config), refreshToken may not be available.
        if (refreshToken && this.isAccessTokenExpired()) {
            return onAccessTokenExpired(function () {
                return _this.exchangeRefreshTokenForAccessToken();
            });
        }
        return Promise.resolve({ token: accessToken, scopes: scopes });
    };
    /**
     * Refresh an access token from the remote service.
     */
    LoginProvider.prototype.exchangeRefreshTokenForAccessToken = function () {
        var _this = this;
        if (!this.acquireRefreshLock())
            return this.waitRefreshLock();
        var _a = this.config, clientId = _a.clientId, tokenUrl = _a.tokenUrl;
        var refreshToken = this.state.refreshToken;
        var url = tokenUrl;
        var body = "grant_type=refresh_token&" +
            "client_id=".concat(clientId, "&") +
            "refresh_token=".concat(refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.value);
        return fetch(url, {
            method: 'POST',
            body: body,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        })
            .then(function (res) {
            if (res.ok)
                return res.json();
            return res
                .json()
                .catch(function () { return ({ error: 'invalid_json' }); })
                .then(function (_a) {
                var error = _a.error;
                throw new StatusError(error, res.status);
            });
        })
            .then(function (_a) {
            var access_token = _a.access_token, expires_in = _a.expires_in, refresh_token = _a.refresh_token, scope = _a.scope;
            return _this.setAccessToken({
                access_token: access_token,
                expires_in: expires_in,
                refresh_token: refresh_token,
                scope: scope,
            });
        })
            .finally(function () { return _this.releaseRefreshLock(); });
    };
    /**
     * Revoke refresh token
     */
    LoginProvider.prototype.revokeRefreshToken = function () {
        var _this = this;
        var _a = this.config, clientId = _a.clientId, revokeUrl = _a.revokeUrl;
        var refreshToken = this.state.refreshToken;
        if (!refreshToken) {
            return Promise.reject(new Error('No refresh token'));
        }
        var url = revokeUrl;
        var body = "client_id=".concat(clientId, "&") + "token=".concat(refreshToken.value);
        return this.getAccessToken()
            .then(function (_a) {
            var token = _a.token;
            if (!token)
                throw new Error('Access token not found');
            return fetch(url, {
                method: 'POST',
                body: body,
                headers: {
                    Authorization: "Bearer ".concat(token.value),
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
        })
            .then(function (res) {
            if (res.ok)
                return _this.reset();
            return res
                .json()
                .catch(function () { return ({ error: 'invalid_json' }); })
                .then(function (_a) {
                var error = _a.error;
                throw new StatusError(error, res.status);
            });
        });
    };
    /**
     * Get the scopes that were granted by the authorization server.
     */
    LoginProvider.prototype.getGrantedScopes = function () {
        return this.state.scopes;
    };
    /**
     * Get the referer that were used by the authorization server.
     */
    LoginProvider.prototype.getReferer = function () {
        return this.state.referer;
    };
    /**
     * Tells if the client is authorized or not. This means the client has at
     * least once successfully fetched an access token. The access token could be
     * expired.
     */
    LoginProvider.prototype.isAuthorized = function () {
        return !!this.state.accessToken;
    };
    /**
     * Checks to see if the access token has expired.
     */
    LoginProvider.prototype.isAccessTokenExpired = function () {
        var accessToken = this.state.accessToken;
        return Boolean(accessToken && new Date() >= new Date(accessToken.expiry));
    };
    /**
     * Resets the state of the client. Equivalent to "logging out" the user.
     */
    LoginProvider.prototype.reset = function () {
        this.setState({});
        this.authCodeForAccessTokenRequest = undefined;
    };
    /**
     * Fetch an access token from the remote service. You may pass a custom
     * authorization grant code for any reason, but this is non-standard usage.
     */
    LoginProvider.prototype.exchangeAuthCodeForAccessToken = function (codeOverride) {
        var _this = this;
        var _a = this.state, _b = _a.authorizationCode, authorizationCode = _b === void 0 ? codeOverride : _b, _c = _a.codeVerifier, codeVerifier = _c === void 0 ? '' : _c;
        var _d = this.config, clientId = _d.clientId, redirectUrl = _d.redirectUrl;
        var url = this.config.tokenUrl;
        var body = "grant_type=authorization_code&" +
            "code=".concat(encodeURIComponent(authorizationCode || ''), "&") +
            "redirect_uri=".concat(encodeURIComponent(redirectUrl), "&") +
            "client_id=".concat(encodeURIComponent(clientId), "&") +
            "code_verifier=".concat(codeVerifier);
        return fetch(url, {
            method: 'POST',
            body: body,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        })
            .then(function (res) {
            if (res.ok)
                return res.json();
            return res
                .json()
                .catch(function () { return ({ error: 'invalid_json' }); })
                .then(function (_a) {
                var error = _a.error;
                throw new StatusError(error, res.status);
            });
        })
            .then(function (_a) {
            var access_token = _a.access_token, expires_in = _a.expires_in, refresh_token = _a.refresh_token, scope = _a.scope;
            _this.state.hasAuthCodeBeenExchangedForAccessToken = true;
            _this.authCodeForAccessTokenRequest = undefined;
            return _this.setAccessToken({
                access_token: access_token,
                expires_in: expires_in,
                refresh_token: refresh_token,
                scope: scope,
            });
        });
    };
    LoginProvider.prototype.fetchWithToken = function (url) {
        return this.getAccessToken()
            .then(function (_a) {
            var token = _a.token;
            if (!token)
                throw new Error('Access token not found');
            return fetch(url, {
                method: 'GET',
                headers: {
                    Authorization: "Bearer ".concat(token.value),
                },
            });
        })
            .then(function (res) {
            if (res.ok)
                return res.json();
            return res
                .json()
                .catch(function () { return ({ error: 'invalid_json' }); })
                .then(function (_a) {
                var error = _a.error;
                throw new StatusError(error, res.status);
            });
        });
    };
    LoginProvider.prototype.setAccessToken = function (_a) {
        var access_token = _a.access_token, expires_in = _a.expires_in, refresh_token = _a.refresh_token, scope = _a.scope;
        var accessToken = {
            value: access_token,
            expiry: new Date(Date.now() + +expires_in * 1000).toString(),
        };
        var refreshToken = refresh_token ? { value: refresh_token } : undefined;
        var scopes = scope ? scope.split(' ') : [];
        this.setState(__assign(__assign({}, this.state), { accessToken: accessToken, refreshToken: refreshToken, scopes: scopes }));
        return { token: accessToken, scopes: scopes };
    };
    LoginProvider.prototype.acquireRefreshLock = function () {
        if (localStorage.getItem(this.refreshLockKey))
            return false;
        localStorage.setItem(this.refreshLockKey, '1'); // Possible race-condition
        return true;
    };
    LoginProvider.prototype.waitRefreshLock = function () {
        var refreshLockKey = this.refreshLockKey;
        var getAccessToken = this.getAccessToken.bind(this);
        var forceReleaseTimeout = setTimeout(function () { return localStorage.removeItem(refreshLockKey); }, 5000);
        return new Promise(function (resolve) {
            var storageEventListener = function (e) {
                if (e.key === refreshLockKey && !e.newValue)
                    out();
            };
            var checkLockInterval = setInterval(function () {
                if (!localStorage.getItem(refreshLockKey))
                    out();
            }, 1000);
            function out() {
                clearInterval(checkLockInterval);
                clearTimeout(forceReleaseTimeout);
                window.removeEventListener('storage', storageEventListener);
                return resolve(getAccessToken());
            }
            window.addEventListener('storage', storageEventListener);
        });
    };
    LoginProvider.prototype.releaseRefreshLock = function () {
        localStorage.removeItem(this.refreshLockKey);
    };
    LoginProvider.prototype.recoverState = function () {
        this.state = JSON.parse(localStorage.getItem(this.localStorageKey) || '{}');
    };
    LoginProvider.prototype.setState = function (state) {
        this.state = state;
        localStorage.setItem(this.localStorageKey, JSON.stringify(state));
    };
    /**
     * Implements *base64url-encode* (RFC 4648 § 5) without padding, which is NOT
     * the same as regular base64 encoding.
     */
    LoginProvider.base64urlEncode = function (value) {
        var base64 = btoa(value);
        base64 = base64.replace(/\+/g, '-');
        base64 = base64.replace(/\//g, '_');
        base64 = base64.replace(/=/g, '');
        return base64;
    };
    /**
     * Extracts a query string parameter.
     */
    LoginProvider.extractParamFromUrl = function (url, param) {
        var queryString = url.split('?');
        if (queryString.length < 2) {
            return '';
        }
        // Account for hash URLs that SPAs usually use.
        queryString = queryString[1].split('#');
        var parts = queryString[0]
            .split('&')
            .reduce(function (a, s) { return a.concat(s.split('=')); }, []);
        if (parts.length < 2) {
            return '';
        }
        var paramIdx = parts.indexOf(param);
        return decodeURIComponent(paramIdx >= 0 ? parts[paramIdx + 1] : '');
    };
    /**
     * Removes the query string parameters to clean up the URL.
     */
    LoginProvider.removeQueryParams = function (url) {
        var _a = url.split('?'), urlPart = _a[0], queryStringAndHashUrlPart = _a[1];
        var _b = queryStringAndHashUrlPart.split('#'), hashUrlPart = _b[1];
        return "".concat(urlPart).concat(hashUrlPart !== undefined ? "#".concat(hashUrlPart) : '');
    };
    /**
     * Generates a code_verifier and code_challenge, as specified in rfc7636.
     */
    LoginProvider.prototype.generatePKCECodes = function () {
        var output = new Uint32Array(exports.RECOMMENDED_CODE_VERIFIER_LENGTH);
        CryptoApi.getRandomValues(output);
        var codeVerifier = LoginProvider.base64urlEncode(Array.from(output)
            .map(function (num) { return PKCE_CHARSET[num % PKCE_CHARSET.length]; })
            .join(''));
        return CryptoApi.sha256(codeVerifier)
            .then(LoginProvider.base64urlEncode)
            .then(function (codeChallenge) { return ({ codeChallenge: codeChallenge, codeVerifier: codeVerifier }); });
    };
    /**
     * Generates random state to be passed for anti-csrf.
     */
    LoginProvider.prototype.generateRandomState = function (lengthOfState) {
        var output = new Uint32Array(lengthOfState);
        CryptoApi.getRandomValues(output);
        return Array.from(output)
            .map(function (num) { return PKCE_CHARSET[num % PKCE_CHARSET.length]; })
            .join('');
    };
    return LoginProvider;
}());
exports.default = LoginProvider;
